/* ==========================================================================
   el-header.js — sections/el-header.liquid
   Bag icon opens the theme's cart drawer (same as the current header);
   the count updates after any cart change on the page. On mobile the menu
   button opens the links drawer (Escape, the backdrop or × close it).
   ========================================================================== */
(function () {
  'use strict';

  /* The theme's cart drawer (cart-drawer.js) looks for the old header's cart icon
     (#cart-icon-bubble) when it starts, and re-renders it after every cart change.
     Without it the drawer never finishes setting up: it won't open on add to cart and
     breaks after a remove. Give it a hidden stand-in next to our bag (only when the
     page has none), so the drawer works the same as with the old header. This file
     loads before cart-drawer.js, so the stand-in is there in time. */
  if (!document.getElementById('cart-icon-bubble')) {
    var bag = document.querySelector('[data-el-header-cart]');
    if (bag) {
      var standIn = document.createElement('span');
      standIn.id = 'cart-icon-bubble';
      standIn.hidden = true;
      standIn.setAttribute('aria-hidden', 'true');
      bag.parentNode.insertBefore(standIn, bag.nextSibling);
    }
  }

  /* Open the drawer instead of following the /cart link (link still works without JS) */
  document.addEventListener('click', function (event) {
    var cartLink = event.target.closest('[data-el-header-cart]');
    if (!cartLink) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    event.preventDefault();
    if (typeof drawer.open === 'function') { try { drawer.open(cartLink); return; } catch (e) {} }
    /* Same fallback as the current header (afina-header.js) when the drawer element isn't upgraded */
    drawer.classList.remove('is-empty');
    drawer.classList.add('active', 'animate');
    drawer.setAttribute('open', '');
    document.body.classList.add('overflow-hidden');
  });

  /* Mobile menu drawer */
  var lastToggle = null;
  function setDrawer(drawer, open) {
    if (!drawer) return;
    drawer.hidden = !open;
    document.querySelectorAll('[data-el-header-open][aria-controls="' + drawer.id + '"]').forEach(function (b) {
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (open) {
      var first = drawer.querySelector('button[data-el-header-close]');
      if (first) first.focus();
    } else if (lastToggle) {
      lastToggle.focus();
    }
  }
  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-el-header-open]');
    if (opener) {
      lastToggle = opener;
      setDrawer(document.getElementById(opener.getAttribute('aria-controls')), true);
      return;
    }
    var closer = event.target.closest('[data-el-header-close]');
    if (closer) setDrawer(closer.closest('[data-el-header-drawer]'), false);
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = document.querySelector('[data-el-header-drawer]:not([hidden])');
    if (open) setDrawer(open, false);
  });
  window.addEventListener('resize', function () {
    if (window.innerWidth < 1024) return;
    var open = document.querySelector('[data-el-header-drawer]:not([hidden])');
    if (open) setDrawer(open, false);
  });

  function updateCount() {
    var counts = document.querySelectorAll('[data-el-header-count]');
    if (!counts.length) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        counts.forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
          var link = el.closest('[data-el-header-cart]');
          if (link) link.setAttribute('aria-label', 'Cart, ' + cart.item_count + ' items');
        });
      })
      .catch(function () {});
  }

  var pending = null;

  /* The theme's own scripts update the current header's count — follow it */
  var bubble = document.getElementById('cart-icon-bubble') || document.querySelector('[data-hdr-count]');
  if (bubble && window.MutationObserver) {
    new MutationObserver(function () { clearTimeout(pending); pending = setTimeout(updateCount, 300); })
      .observe(bubble, { childList: true, subtree: true, characterData: true });
  }

  /* Refresh after any cart write made with fetch (product pages, drawer, apps) */
  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var result = nativeFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
        result.then(function () {
          clearTimeout(pending);
          pending = setTimeout(updateCount, 300);
        }).catch(function () {});
      }
      return result;
    };
  }
})();
